import React from 'react'
import SweetAlertContainer from '../../../Components/BonusUi/SweetAlert2'

export default function SweetAlert() {
  return (
    <div className='page-body'>
        <SweetAlertContainer/>
    </div>
  )
}
